import { http } from '@pendo/http';
import isArray from 'lodash/isArray';
import isInteger from 'lodash/isInteger';
import flatMap from 'lodash/flatMap';

export const ALL_PLATFORM = '*';

export const MOBILE_PLATFORMS = ['ios', 'android'];

export const IOS_PLATFORM = 'ios';

export const ANDROID_PLATFORM = 'android';

export const MOBILE_PLATFORM = 'mobile';

export const WEB_PLATFORM = 'web';

export const EXTENSION_PLATFORM = 'extension';

export const ALL_PLATFORM_LABEL = 'All Apps';

export const IOS_PLATFORM_LABEL = 'iOS';

export const ANDROID_PLATFORM_LABEL = 'Android';

export const WEB_PLATFORM_LABEL = 'Web';

export const EXTENSION_PLATFORM_LABEL = 'Extension';

export const UNKNOWN_PLATFORM_LABEL = 'Unknown';

export const IOS_AGG_ID = 'expandAppIds("ios")';

export const ANDROID_AGG_ID = 'expandAppIds("android")';

export const WEB_AGG_ID = 'expandAppIds("web")';

export const ALL_AGG_ID = 'expandAppIds("*")';

export const MOBILE_AGG_ID = 'expandAppIds("mobile")';

export const EXTENSION_AGG_ID = 'expandAppIds("extension")';

export const RETRO_MOBILE_AGG_ID = 'expandAppIds("mobile-retro")';

export const RETRO_ANALYTICS_AGG_ID = 'expandAppIds("web|mobile-retro|extension")';

export const WEB_LIKE_AGG_ID = 'expandAppIds("web|extension")';

export const OPTION_DISPLAY_MAP = {
    'all': 'All Apps',
    '*': 'All Apps',
    'web': 'Web Apps',
    'ios': 'Mobile Apps',
    'android': 'Mobile Apps',
    'mobile': 'Mobile Apps',
    'extension': 'Extension Apps',
};

export function getAllApps () {
    return http.get('api/s/_SID_/application');
}

export function expandAppIds (appId, apps) {
    const appIds = isArray(appId) ? appId : [appId];

    return flatMap(
        appIds.map((id) => {
            switch (id) {
                case ALL_AGG_ID:
                    return apps.map((app) => app.id);
                case IOS_AGG_ID:
                    return apps.filter((app) => app.platform === IOS_PLATFORM).map((app) => app.id);
                case ANDROID_AGG_ID:
                    return apps.filter((app) => app.platform === ANDROID_PLATFORM).map((app) => app.id);
                case MOBILE_AGG_ID:
                    return apps.filter((app) => MOBILE_PLATFORMS.includes(app.platform)).map((app) => app.id);
                case WEB_AGG_ID:
                    return apps.filter((app) => app.platform === WEB_PLATFORM).map((app) => app.id);
                case EXTENSION_AGG_ID:
                    return apps.filter((app) => app.platform === EXTENSION_PLATFORM).map((app) => app.id);
                default:
                    return appId;
            }
        }),
    );
}

export function getDefaultOptionFromAppId (appId) {
    if (!appId || isInteger(appId)) return;
    if (isArray(appId)) {
        if (appId.includes(IOS_AGG_ID) || appId.includes(ANDROID_AGG_ID)) {
            return OPTION_DISPLAY_MAP.mobile;
        }

        return;
    }

    appId = appId.replace(/expandAppIds|\("|"\)/g, '');

    return OPTION_DISPLAY_MAP[appId];
}

// Angular formats mobile apps selection that originate on the vue version of the global filter bar
// as [expandAppIds('ios'), expandAppIds('android')]
export const formatAngularAppId = (appId) => {
    if (Array.isArray(appId) && appId.includes(IOS_AGG_ID)) {
        return [MOBILE_AGG_ID];
    }

    return appId;
};
